import { render, staticRenderFns } from "./ListPerSupplier.vue?vue&type=template&id=5e84d920&scoped=true"
import script from "./ListPerSupplier.vue?vue&type=script&lang=js"
export * from "./ListPerSupplier.vue?vue&type=script&lang=js"
import style0 from "./ListPerSupplier.vue?vue&type=style&index=0&id=5e84d920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e84d920",
  null
  
)

export default component.exports